import { TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';

const useAccountSearchColumns = (): TableColumnsType<any> => {
  const { t } = useTranslation('Vindoc');

  return [
    {
      title: t('Full Name'),
      width: 200,
      dataIndex: 'fullname',
      key: 'fullname',
      ellipsis: true,
    },
    {
      title: t('Username'),
      width: 110,
      dataIndex: 'username',
      key: 'username',
      ellipsis: true,
    },
    /* {
      title: t('Status'),
      width: 70,
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      render: (status) => ACCOUNT_STATUS[status],
    }, */
    // {
    //   title: t('Institution'),
    //   dataIndex: ['institution', 'name'],
    //   key: 'institution.name',
    //   width: 180,
    //   ellipsis: true,
    // },
    {
      title: t('Roles'),
      dataIndex: 'roles',
      key: 'roles',
      width: 120,
      ellipsis: true,
      render: (text, record) => {
        const roles = (record?.roles || []).map((role) => t(role));

        return roles ? roles.join(', ') : '-';
      },
    },
  ];
};

export default useAccountSearchColumns;
